import { useCallback } from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import MuiTextField from '@mui/material/TextField';

import Autocomplete from '@gef-ui/form-material/Autocomplete';

// used for options where labels are not unique - since MUI use labels as keys by default
export const AutocompleteCustomOptionKey = ({ keyPropName = 'label', label, ...rest }) => {
	const getOptionLabel = useCallback((option) => option.label, []);

	const renderOption = useCallback(
		(props, option) => (
			<Box component="li" {...props} key={option[keyPropName]}>
				{option.label}
			</Box>
		),
		[keyPropName],
	);

	const renderInput = useCallback(
		(params) => (
			<MuiTextField
				{...params}
				label={label}
				fullWidth
				slotProps={{
					input: {
						...params?.InputProps,
					},
				}}
			/>
		),
		[label],
	);

	return (
		<Autocomplete
			{...rest}
			label={label}
			getOptionLabel={getOptionLabel}
			renderOption={renderOption}
			renderInput={renderInput}
		/>
	);
};

AutocompleteCustomOptionKey.propTypes = {
	keyPropName: PropTypes.string,
	label: PropTypes.string,
};

export default AutocompleteCustomOptionKey;
